/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Created_OnInputs */

const en_created_on = /** @type {(inputs: Created_OnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Created On`)
};

const fr_created_on = /** @type {(inputs: Created_OnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Créé le`)
};

const de_created_on = /** @type {(inputs: Created_OnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erstellt am`)
};

const it_created_on = /** @type {(inputs: Created_OnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creato il`)
};

const ru_created_on = /** @type {(inputs: Created_OnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Создано в`)
};

const es_created_on = /** @type {(inputs: Created_OnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creado el`)
};

const zh_cn2_created_on = /** @type {(inputs: Created_OnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`创建于`)
};

const ja_created_on = /** @type {(inputs: Created_OnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`作成日`)
};

const hi_created_on = /** @type {(inputs: Created_OnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`पर बनाया`)
};

const pt_pt2_created_on = /** @type {(inputs: Created_OnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Criado em`)
};

/**
* | output |
* | --- |
* | "Created On" |
*
* @param {Created_OnInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const created_on = /** @type {((inputs?: Created_OnInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Created_OnInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_created_on(inputs)
	if (locale === "de") return de_created_on(inputs)
	if (locale === "it") return it_created_on(inputs)
	if (locale === "ru") return ru_created_on(inputs)
	if (locale === "es") return es_created_on(inputs)
	if (locale === "zh-CN") return zh_cn2_created_on(inputs)
	if (locale === "ja") return ja_created_on(inputs)
	if (locale === "hi") return hi_created_on(inputs)
	if (locale === "pt-PT") return pt_pt2_created_on(inputs)
	return en_created_on(inputs)
});